/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proresp.AskResponse', null, global);
goog.exportSymbol('proto.proresp.Barrage', null, global);
goog.exportSymbol('proto.proresp.BarrageArr', null, global);
goog.exportSymbol('proto.proresp.BizType', null, global);
goog.exportSymbol('proto.proresp.BroadMsgReponse', null, global);
goog.exportSymbol('proto.proresp.FriendResponse', null, global);
goog.exportSymbol('proto.proresp.MsgAckReponse', null, global);
goog.exportSymbol('proto.proresp.MsgType', null, global);
goog.exportSymbol('proto.proresp.PointMsgReponse', null, global);
goog.exportSymbol('proto.proresp.Response', null, global);
goog.exportSymbol('proto.proresp.TaskFinishNotify', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.Response.displayName = 'proto.proresp.Response';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    databytes: msg.getDatabytes_asB64(),
    errcode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    errmsg: jspb.Message.getField(msg, 4),
    uuid: jspb.Message.getField(msg, 5),
    time: jspb.Message.getField(msg, 6),
    userid: jspb.Message.getField(msg, 7)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.Response}
 */
proto.proresp.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.Response;
  return proto.proresp.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.Response}
 */
proto.proresp.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDatabytes(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setErrcode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrmsg(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * required int32 code = 1;
 * @return {number}
 */
proto.proresp.Response.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.proresp.Response.prototype.setCode = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.Response.prototype.clearCode = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes databytes = 2;
 * @return {!(string|Uint8Array)}
 */
proto.proresp.Response.prototype.getDatabytes = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes databytes = 2;
 * This is a type-conversion wrapper around `getDatabytes()`
 * @return {string}
 */
proto.proresp.Response.prototype.getDatabytes_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDatabytes()));
};


/**
 * optional bytes databytes = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDatabytes()`
 * @return {!Uint8Array}
 */
proto.proresp.Response.prototype.getDatabytes_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDatabytes()));
};


/** @param {!(string|Uint8Array)} value */
proto.proresp.Response.prototype.setDatabytes = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.Response.prototype.clearDatabytes = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasDatabytes = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 errCode = 3;
 * @return {number}
 */
proto.proresp.Response.prototype.getErrcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.proresp.Response.prototype.setErrcode = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.proresp.Response.prototype.clearErrcode = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasErrcode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string errMsg = 4;
 * @return {string}
 */
proto.proresp.Response.prototype.getErrmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proresp.Response.prototype.setErrmsg = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.proresp.Response.prototype.clearErrmsg = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasErrmsg = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string uuid = 5;
 * @return {string}
 */
proto.proresp.Response.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proresp.Response.prototype.setUuid = function(value) {
  jspb.Message.setField(this, 5, value);
};


proto.proresp.Response.prototype.clearUuid = function() {
  jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string time = 6;
 * @return {string}
 */
proto.proresp.Response.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proresp.Response.prototype.setTime = function(value) {
  jspb.Message.setField(this, 6, value);
};


proto.proresp.Response.prototype.clearTime = function() {
  jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string userId = 7;
 * @return {string}
 */
proto.proresp.Response.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.proresp.Response.prototype.setUserid = function(value) {
  jspb.Message.setField(this, 7, value);
};


proto.proresp.Response.prototype.clearUserid = function() {
  jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Response.prototype.hasUserid = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.AskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.AskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.AskResponse.displayName = 'proto.proresp.AskResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.AskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.AskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.AskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.AskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getField(msg, 1),
    friend: (f = msg.getFriend()) && proto.proresp.FriendResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.AskResponse}
 */
proto.proresp.AskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.AskResponse;
  return proto.proresp.AskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.AskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.AskResponse}
 */
proto.proresp.AskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.proresp.FriendResponse;
      reader.readMessage(value,proto.proresp.FriendResponse.deserializeBinaryFromReader);
      msg.setFriend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.AskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.AskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.AskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.AskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFriend();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proresp.FriendResponse.serializeBinaryToWriter
    );
  }
};


/**
 * required string id = 1;
 * @return {string}
 */
proto.proresp.AskResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.AskResponse.prototype.setId = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.AskResponse.prototype.clearId = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.AskResponse.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FriendResponse friend = 2;
 * @return {?proto.proresp.FriendResponse}
 */
proto.proresp.AskResponse.prototype.getFriend = function() {
  return /** @type{?proto.proresp.FriendResponse} */ (
    jspb.Message.getWrapperField(this, proto.proresp.FriendResponse, 2));
};


/** @param {?proto.proresp.FriendResponse|undefined} value */
proto.proresp.AskResponse.prototype.setFriend = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.proresp.AskResponse.prototype.clearFriend = function() {
  this.setFriend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.AskResponse.prototype.hasFriend = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.FriendResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.FriendResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.FriendResponse.displayName = 'proto.proresp.FriendResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.FriendResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.FriendResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.FriendResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.FriendResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getField(msg, 1),
    uid: jspb.Message.getField(msg, 2),
    nickname: jspb.Message.getField(msg, 3),
    sign: jspb.Message.getField(msg, 4),
    head: jspb.Message.getField(msg, 5)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.FriendResponse}
 */
proto.proresp.FriendResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.FriendResponse;
  return proto.proresp.FriendResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.FriendResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.FriendResponse}
 */
proto.proresp.FriendResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSign(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHead(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.FriendResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.FriendResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.FriendResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.FriendResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * required string id = 1;
 * @return {string}
 */
proto.proresp.FriendResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.FriendResponse.prototype.setId = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.FriendResponse.prototype.clearId = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.FriendResponse.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string uid = 2;
 * @return {string}
 */
proto.proresp.FriendResponse.prototype.getUid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proresp.FriendResponse.prototype.setUid = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.FriendResponse.prototype.clearUid = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.FriendResponse.prototype.hasUid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required string nickname = 3;
 * @return {string}
 */
proto.proresp.FriendResponse.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proresp.FriendResponse.prototype.setNickname = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.proresp.FriendResponse.prototype.clearNickname = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.FriendResponse.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string sign = 4;
 * @return {string}
 */
proto.proresp.FriendResponse.prototype.getSign = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proresp.FriendResponse.prototype.setSign = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.proresp.FriendResponse.prototype.clearSign = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.FriendResponse.prototype.hasSign = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string head = 5;
 * @return {string}
 */
proto.proresp.FriendResponse.prototype.getHead = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proresp.FriendResponse.prototype.setHead = function(value) {
  jspb.Message.setField(this, 5, value);
};


proto.proresp.FriendResponse.prototype.clearHead = function() {
  jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.FriendResponse.prototype.hasHead = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.MsgAckReponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.MsgAckReponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.MsgAckReponse.displayName = 'proto.proresp.MsgAckReponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.MsgAckReponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.MsgAckReponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.MsgAckReponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.MsgAckReponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    msgno: jspb.Message.getField(msg, 1),
    time: jspb.Message.getField(msg, 2)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.MsgAckReponse}
 */
proto.proresp.MsgAckReponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.MsgAckReponse;
  return proto.proresp.MsgAckReponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.MsgAckReponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.MsgAckReponse}
 */
proto.proresp.MsgAckReponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgno(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.MsgAckReponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.MsgAckReponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.MsgAckReponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.MsgAckReponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * required string msgNo = 1;
 * @return {string}
 */
proto.proresp.MsgAckReponse.prototype.getMsgno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.MsgAckReponse.prototype.setMsgno = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.MsgAckReponse.prototype.clearMsgno = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.MsgAckReponse.prototype.hasMsgno = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string time = 2;
 * @return {string}
 */
proto.proresp.MsgAckReponse.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proresp.MsgAckReponse.prototype.setTime = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.MsgAckReponse.prototype.clearTime = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.MsgAckReponse.prototype.hasTime = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.PointMsgReponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.PointMsgReponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.PointMsgReponse.displayName = 'proto.proresp.PointMsgReponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.PointMsgReponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.PointMsgReponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.PointMsgReponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.PointMsgReponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    senderid: jspb.Message.getField(msg, 1),
    type: jspb.Message.getField(msg, 2),
    context: jspb.Message.getField(msg, 3),
    msgno: jspb.Message.getField(msg, 4),
    time: jspb.Message.getField(msg, 5),
    off: jspb.Message.getField(msg, 6)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.PointMsgReponse}
 */
proto.proresp.PointMsgReponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.PointMsgReponse;
  return proto.proresp.PointMsgReponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.PointMsgReponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.PointMsgReponse}
 */
proto.proresp.PointMsgReponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderid(value);
      break;
    case 2:
      var value = /** @type {!proto.proresp.MsgType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContext(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgno(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.PointMsgReponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.PointMsgReponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.PointMsgReponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.PointMsgReponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!proto.proresp.MsgType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * required string senderId = 1;
 * @return {string}
 */
proto.proresp.PointMsgReponse.prototype.getSenderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.PointMsgReponse.prototype.setSenderid = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.PointMsgReponse.prototype.clearSenderid = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.PointMsgReponse.prototype.hasSenderid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required MsgType type = 2;
 * @return {!proto.proresp.MsgType}
 */
proto.proresp.PointMsgReponse.prototype.getType = function() {
  return /** @type {!proto.proresp.MsgType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.proresp.MsgType} value */
proto.proresp.PointMsgReponse.prototype.setType = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.PointMsgReponse.prototype.clearType = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.PointMsgReponse.prototype.hasType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required string context = 3;
 * @return {string}
 */
proto.proresp.PointMsgReponse.prototype.getContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proresp.PointMsgReponse.prototype.setContext = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.proresp.PointMsgReponse.prototype.clearContext = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.PointMsgReponse.prototype.hasContext = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required string msgNo = 4;
 * @return {string}
 */
proto.proresp.PointMsgReponse.prototype.getMsgno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proresp.PointMsgReponse.prototype.setMsgno = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.proresp.PointMsgReponse.prototype.clearMsgno = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.PointMsgReponse.prototype.hasMsgno = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required string time = 5;
 * @return {string}
 */
proto.proresp.PointMsgReponse.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proresp.PointMsgReponse.prototype.setTime = function(value) {
  jspb.Message.setField(this, 5, value);
};


proto.proresp.PointMsgReponse.prototype.clearTime = function() {
  jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.PointMsgReponse.prototype.hasTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required bool off = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.proresp.PointMsgReponse.prototype.getOff = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.proresp.PointMsgReponse.prototype.setOff = function(value) {
  jspb.Message.setField(this, 6, value);
};


proto.proresp.PointMsgReponse.prototype.clearOff = function() {
  jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.PointMsgReponse.prototype.hasOff = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.BroadMsgReponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.BroadMsgReponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.BroadMsgReponse.displayName = 'proto.proresp.BroadMsgReponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.BroadMsgReponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.BroadMsgReponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.BroadMsgReponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.BroadMsgReponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupid: jspb.Message.getField(msg, 1),
    senderid: jspb.Message.getField(msg, 2),
    type: jspb.Message.getField(msg, 3),
    context: jspb.Message.getField(msg, 4),
    msgno: jspb.Message.getField(msg, 5),
    time: jspb.Message.getField(msg, 6)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.BroadMsgReponse}
 */
proto.proresp.BroadMsgReponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.BroadMsgReponse;
  return proto.proresp.BroadMsgReponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.BroadMsgReponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.BroadMsgReponse}
 */
proto.proresp.BroadMsgReponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderid(value);
      break;
    case 3:
      var value = /** @type {!proto.proresp.MsgType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContext(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgno(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.BroadMsgReponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.BroadMsgReponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.BroadMsgReponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.BroadMsgReponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.proresp.MsgType} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * required string groupId = 1;
 * @return {string}
 */
proto.proresp.BroadMsgReponse.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.BroadMsgReponse.prototype.setGroupid = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.BroadMsgReponse.prototype.clearGroupid = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.BroadMsgReponse.prototype.hasGroupid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string senderId = 2;
 * @return {string}
 */
proto.proresp.BroadMsgReponse.prototype.getSenderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proresp.BroadMsgReponse.prototype.setSenderid = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.BroadMsgReponse.prototype.clearSenderid = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.BroadMsgReponse.prototype.hasSenderid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required MsgType type = 3;
 * @return {!proto.proresp.MsgType}
 */
proto.proresp.BroadMsgReponse.prototype.getType = function() {
  return /** @type {!proto.proresp.MsgType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.proresp.MsgType} value */
proto.proresp.BroadMsgReponse.prototype.setType = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.proresp.BroadMsgReponse.prototype.clearType = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.BroadMsgReponse.prototype.hasType = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * required string context = 4;
 * @return {string}
 */
proto.proresp.BroadMsgReponse.prototype.getContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proresp.BroadMsgReponse.prototype.setContext = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.proresp.BroadMsgReponse.prototype.clearContext = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.BroadMsgReponse.prototype.hasContext = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required string msgNo = 5;
 * @return {string}
 */
proto.proresp.BroadMsgReponse.prototype.getMsgno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.proresp.BroadMsgReponse.prototype.setMsgno = function(value) {
  jspb.Message.setField(this, 5, value);
};


proto.proresp.BroadMsgReponse.prototype.clearMsgno = function() {
  jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.BroadMsgReponse.prototype.hasMsgno = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * required string time = 6;
 * @return {string}
 */
proto.proresp.BroadMsgReponse.prototype.getTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.proresp.BroadMsgReponse.prototype.setTime = function(value) {
  jspb.Message.setField(this, 6, value);
};


proto.proresp.BroadMsgReponse.prototype.clearTime = function() {
  jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.BroadMsgReponse.prototype.hasTime = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.BarrageArr = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proresp.BarrageArr.repeatedFields_, null);
};
goog.inherits(proto.proresp.BarrageArr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.BarrageArr.displayName = 'proto.proresp.BarrageArr';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proresp.BarrageArr.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.BarrageArr.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.BarrageArr.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.BarrageArr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.BarrageArr.toObject = function(includeInstance, msg) {
  var f, obj = {
    barragesList: jspb.Message.toObjectList(msg.getBarragesList(),
    proto.proresp.Barrage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.BarrageArr}
 */
proto.proresp.BarrageArr.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.BarrageArr;
  return proto.proresp.BarrageArr.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.BarrageArr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.BarrageArr}
 */
proto.proresp.BarrageArr.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proresp.Barrage;
      reader.readMessage(value,proto.proresp.Barrage.deserializeBinaryFromReader);
      msg.addBarrages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.BarrageArr.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.BarrageArr.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.BarrageArr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.BarrageArr.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBarragesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proresp.Barrage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Barrage barrages = 1;
 * @return {!Array<!proto.proresp.Barrage>}
 */
proto.proresp.BarrageArr.prototype.getBarragesList = function() {
  return /** @type{!Array<!proto.proresp.Barrage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proresp.Barrage, 1));
};


/** @param {!Array<!proto.proresp.Barrage>} value */
proto.proresp.BarrageArr.prototype.setBarragesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proresp.Barrage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proresp.Barrage}
 */
proto.proresp.BarrageArr.prototype.addBarrages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proresp.Barrage, opt_index);
};


proto.proresp.BarrageArr.prototype.clearBarragesList = function() {
  this.setBarragesList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.Barrage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.Barrage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.Barrage.displayName = 'proto.proresp.Barrage';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.Barrage.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.Barrage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.Barrage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.Barrage.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getField(msg, 1),
    nickname: jspb.Message.getField(msg, 2),
    head: jspb.Message.getField(msg, 3),
    customtext: jspb.Message.getField(msg, 4),
    type: jspb.Message.getField(msg, 5)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.Barrage}
 */
proto.proresp.Barrage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.Barrage;
  return proto.proresp.Barrage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.Barrage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.Barrage}
 */
proto.proresp.Barrage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHead(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomtext(value);
      break;
    case 5:
      var value = /** @type {!proto.proresp.BizType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.Barrage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.Barrage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.Barrage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.Barrage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.proresp.BizType} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * required string id = 1;
 * @return {string}
 */
proto.proresp.Barrage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.Barrage.prototype.setId = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.Barrage.prototype.clearId = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Barrage.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string nickname = 2;
 * @return {string}
 */
proto.proresp.Barrage.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proresp.Barrage.prototype.setNickname = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.Barrage.prototype.clearNickname = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Barrage.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string head = 3;
 * @return {string}
 */
proto.proresp.Barrage.prototype.getHead = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proresp.Barrage.prototype.setHead = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.proresp.Barrage.prototype.clearHead = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Barrage.prototype.hasHead = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string customText = 4;
 * @return {string}
 */
proto.proresp.Barrage.prototype.getCustomtext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.proresp.Barrage.prototype.setCustomtext = function(value) {
  jspb.Message.setField(this, 4, value);
};


proto.proresp.Barrage.prototype.clearCustomtext = function() {
  jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Barrage.prototype.hasCustomtext = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * required BizType type = 5;
 * @return {!proto.proresp.BizType}
 */
proto.proresp.Barrage.prototype.getType = function() {
  return /** @type {!proto.proresp.BizType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.proresp.BizType} value */
proto.proresp.Barrage.prototype.setType = function(value) {
  jspb.Message.setField(this, 5, value);
};


proto.proresp.Barrage.prototype.clearType = function() {
  jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.Barrage.prototype.hasType = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proresp.TaskFinishNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proresp.TaskFinishNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.proresp.TaskFinishNotify.displayName = 'proto.proresp.TaskFinishNotify';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proresp.TaskFinishNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proresp.TaskFinishNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proresp.TaskFinishNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.TaskFinishNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    tasktype: jspb.Message.getField(msg, 1),
    prizetype: jspb.Message.getField(msg, 2),
    content: jspb.Message.getField(msg, 3)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proresp.TaskFinishNotify}
 */
proto.proresp.TaskFinishNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proresp.TaskFinishNotify;
  return proto.proresp.TaskFinishNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proresp.TaskFinishNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proresp.TaskFinishNotify}
 */
proto.proresp.TaskFinishNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrizetype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proresp.TaskFinishNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proresp.TaskFinishNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proresp.TaskFinishNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proresp.TaskFinishNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * required string taskType = 1;
 * @return {string}
 */
proto.proresp.TaskFinishNotify.prototype.getTasktype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.proresp.TaskFinishNotify.prototype.setTasktype = function(value) {
  jspb.Message.setField(this, 1, value);
};


proto.proresp.TaskFinishNotify.prototype.clearTasktype = function() {
  jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.TaskFinishNotify.prototype.hasTasktype = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * required string prizeType = 2;
 * @return {string}
 */
proto.proresp.TaskFinishNotify.prototype.getPrizetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.proresp.TaskFinishNotify.prototype.setPrizetype = function(value) {
  jspb.Message.setField(this, 2, value);
};


proto.proresp.TaskFinishNotify.prototype.clearPrizetype = function() {
  jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.TaskFinishNotify.prototype.hasPrizetype = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * required string content = 3;
 * @return {string}
 */
proto.proresp.TaskFinishNotify.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.proresp.TaskFinishNotify.prototype.setContent = function(value) {
  jspb.Message.setField(this, 3, value);
};


proto.proresp.TaskFinishNotify.prototype.clearContent = function() {
  jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.proresp.TaskFinishNotify.prototype.hasContent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.proresp.MsgType = {
  TEXT: 0,
  IMG: 1,
  SOUND: 2
};

/**
 * @enum {number}
 */
proto.proresp.BizType = {
  REDPACKET: 0,
  PAID_ORDER: 1,
  FREE_ORDER: 2,
  NULL: 3
};

goog.object.extend(exports, proto.proresp);



// WEBPACK FOOTER //
// ./src/proto/response_pb.js